import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import BusinessPage from "./pages/BusinessPage";
import HarvestPage from "./pages/HarvestPage";
import SponsorshipPage from "./pages/SponsorshipPage";
import GalleryPage from "./pages/GalleryPage";
import PortalPage from "./pages/PortalPage";
import WeatherPage from "./pages/WeatherPage";
import NutrienPage from "./pages/NutrienPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/business" element={<BusinessPage />} />
          <Route path="/our-business" element={<BusinessPage />} />
          <Route path="/harvest" element={<HarvestPage />} />
          <Route path="/sponsorship" element={<SponsorshipPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/portal" element={<PortalPage />} />
          <Route path="/grower-portal" element={<PortalPage />} />
          <Route path="/weather" element={<WeatherPage />} />
          <Route path="/nutrien" element={<NutrienPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
